/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeRegistrationLoginDetails } from '../../models/employee-registration-login-details';

export interface GetLoginDetails$Params {
  workCenterId: number;
  employeeId: number;
}

export function getLoginDetails(http: HttpClient, rootUrl: string, params: GetLoginDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<EmployeeRegistrationLoginDetails>> {
  const rb = new RequestBuilder(rootUrl, getLoginDetails.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.path('employeeId', params.employeeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmployeeRegistrationLoginDetails>;
    })
  );
}

getLoginDetails.PATH = '/api/v1/{workCenterId}/GetLoginDetails/{employeeId}';
